import { Leaderboard } from '@/features/leaderboard/components/Leaderboard'
import { Page } from '@/ui-kit'

export const LeaderboardPage = () => {
  return (
    <Page>
      <Leaderboard />
    </Page>
  )
}

export default LeaderboardPage
